<template>
    <v-menu v-model="showMenu" :position-x="posX" :position-y="posY" absolute offset-y>
        <v-list>
            <v-list-tile v-if="canRegenerate" @click="regenerateThumbnail">
                <v-list-tile-content>
                    <v-list-tile-title>Regénérer</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon color="green lighten-1">refresh</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-list-tile @click="rotateLeft">
                <v-list-tile-content>
                    <v-list-tile-title>Retourner à gauche</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon color="grey lighten-1">rotate_left</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-list-tile @click="rotateRight">
                <v-list-tile-content>
                    <v-list-tile-title>Retourner à droite</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon color="grey lighten-1">rotate_right</v-icon>
                </v-list-tile-action>
            </v-list-tile>

            <v-list-tile @click="deleteDocument">
                <v-list-tile-content>
                    <v-list-tile-title>Supprimer</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                    <v-icon color="red lighten-1">delete_forever</v-icon>
                </v-list-tile-action>
            </v-list-tile>
        </v-list>
    </v-menu>
</template>

<script>
    import {DocumentService} from "../../services/document.service";
    import {DIRECTORY_FETCH, DOCUMENT_ROTATE} from "../../store/actions.type";

    export default {
        name: "DocumentItemAdminMenu",
        props: {
            document: {
                type: Object,
                default: null
            }
        },
        data: () => ({
            posX: 0,
            posY: 0,
            showMenu: false,
        }),
        computed: {
            canRegenerate: function () {
                return !this.document.thumbnailPath && this.document.canHaveThumbnail;
            }
        },
        methods: {
            /**
             * Suppression d'un document
             */
            deleteDocument: function () {
                this.$confirm('Voulez-vous vraiment supprimer cette image ?').then(res => {
                    if (res) {
                        DocumentService.delete(this.document.slug).then(() => {
                            this.$store.dispatch(DIRECTORY_FETCH, this.$route.params.slug);
                        });
                    }
                });
            },

            /**
             * Ouvre le menu
             */
            open: function(e) {
                this.showMenu = true;
                this.posX = e.clientX;
                this.posY = e.clientY;
            },

            /**
             * Regénération du thumbnail
             */
            regenerateThumbnail: function () {
                DocumentService.regenerateThumbnail(this.document.slug).then(() => {
                    this.$store.dispatch(DIRECTORY_FETCH, this.$route.params.slug);
                });
            },

            /**
             * Rotation de l'image
             */
            rotateLeft: function () {
                this.$store.dispatch(DOCUMENT_ROTATE, {
                    documentSlug: this.document.slug,
                    angle: 90
                });
            },

            /**
             * Rotation de l'image
             */
            rotateRight: function () {
                this.$store.dispatch(DOCUMENT_ROTATE, {
                    documentSlug: this.document.slug,
                    angle: -90
                });
            }
        }
    };
</script>

<style scoped lang="scss">
</style>
